// extracted by mini-css-extract-plugin
var _1 = "EntityPhaseLoading-moduleEntityPhaseLoading__HlOoQ";
var _2 = "EntityPhaseLoading-moduleskeleton__Aso_9 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "EntityPhaseLoading", _2 as "skeleton" }
